<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 16:56:53
 * @LastEditTime: 2019-10-10 00:35:02
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    class="copyDialog"
    title="复制链接"
    :visible="true"
    width="40%"
    :before-close="handleClose"
  >
    <div id="qrcode" style="width: 130px; height: 130px; margin: 10px"></div>
    <span style="margin: 10px">微信扫一扫立即预览</span>
    <div class="address">
      <p>链接地址</p>
      <el-input
        v-model="url"
        style="width: 240px; margin: 10px 10px 30px 0"
        readonly
      ></el-input>
      <el-button
        type="primary"
        @click="copy()"
        ref="copy"
        :data-clipboard-text="url"
        class="copy_text"
        >复制</el-button
      >
      <p>将此链接复制到公众号菜单栏</p>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import Clipboard from "clipboard";
import VueCookie from "vue-cookie";
export default {
  name: "copy-link-dialog",
  data() {
    return {
      url: "",
    };
  },
  props: {
    link: String,
  },
  methods: {
    init() {
      if (process.NODE_ENV == "development") {
        var host = "https://jifen.tx315.vip";
        this.url =
          host +
          "/HQ/index.html#/hqTrackingQueries?customer_id=" +
          VueCookie.get("customer_id");
      } else {
        var host = "https://jifen.tx315.vip";
        this.url =
          host +
          "/HQ/index.html#/hqTrackingQueries?customer_id=" +
          VueCookie.get("customer_id");
      }
      if (this.link) {
        this.url = this.link;
      }
      this.qrcode();
    },
    //二维码
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 130,
        height: 130, // 高度
        text: this.url, // 二维码内容
      });
    },
    //复制url
    copy() {
      var clipboard = new Clipboard(".copy_text");
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制成功",
          type: "success",
        });
        this.handleClose();
        // 释放内存
        //clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("复制失败，请重试！");
        this.handleClose();
        // 释放内存
        //clipboard.destroy()
      });
    },
    handleClose() {
      this.$emit("handleClose");
    },
  },
  created() {
    this.$nextTick(function() {
      this.init();
    });
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.copyDialog {
  .address {
    position: absolute;
    top: 70px;
    left: 180px;
    width: 100%;
    height: 130px;
    border-left: 1px solid #ccc;
    padding-left: 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
}
</style>
